// images
import blogImg1 from "../images/blog/blog1.png";
import blogImg2 from "../images/blog/blog2.jpeg";
import blogImg3 from "../images/blog/blog3.png";

import blogSingleImg1 from "../images/blog/blog1.png";
import blogSingleImg2 from "../images/blog/blog2.jpeg";
import blogSingleImg3 from "../images/blog/blog3.png";




const blogs = [
    {
        id: '1',
        title: 'Passare alla lettiera automatica: 5 consigli per non stressare il gatto.',
        title2: 'La guida definitiva per aiutare il tuo micio ad abituarsi a Kleeo in meno di 48 ore senza traumi.',
        subtitle: 'Team Kleeo',
        slug: 'guida-passaggio-lettiera-automatica',
        screens: blogImg1,
        link: 'LEGGI TUTTO',
        description: 'La guida definitiva per aiutare il tuo micio ad abituarsi a Kleeo in meno di 48 ore senza traumi.',
        author: 'Team Kleeo',
        create_at: 'Feb 10, 2026',
        blogSingleImg: blogSingleImg1,
        comment: '35',
        day: '10',
        month: 'FEB',
        blClass: 'format-standard-image',
        animation: '1200',
        tags: ['Guida all\'uso', 'Adattamento Gatto', 'Lettiera Automatica', 'Benessere Felino', 'Consigli Kleeo'],
        content: [
            'Il passaggio da una lettiera tradizionale a una tecnologica è un momento delicato. ' +
            'Anche se Kleeo è progettata per essere silenziosa e accogliente, alcuni gatti possono essere sospettosi verso le novità. ' +
            'Ecco perché abbiamo preparato questa guida in 5 passi per rendere il passaggio a Kleeo il più sereno possibile.',
            '1. Non buttare subito la vecchia lettiera: Posiziona Kleeo accanto a quella attuale per qualche giorno senza attivarla. Lascia che il gatto la esplori a motore spento, di sua spontanea volontà, senza forzarlo.',
            '2. Usa la sua sabbia preferita: Inizialmente, riempi Kleeo con la sabbia a cui il gatto è abituato. L\'odore familiare lo rassicurerà.',
            '3. Il trucco della "vecchia sabbia": Aggiungi una piccola manciata di sabbia usata (pulita) nella Kleeo. L\'odore lo aiuterà a capire che quello è il suo nuovo bagno.',
            '4. Premia la curiosità: Se vedi il tuo gatto avvicinarsi o entrare, premialo con uno snack. Deve associare Kleeo a un\'esperienza positiva',
            '5. Attiva il ciclo automatico solo dopo il primo uso: Una volta che ha iniziato a usarla con regolarità, attiva le funzioni smart. Grazie ai suoi 45dB, Kleeo non lo spaventerà durante il ciclo di pulizia.',
        ],
    },
    {
        id: '2',
        title: 'Perché la sicurezza "Safe-Dome" di Kleeo è superiore ai modelli rotanti.',
        title2: 'Analizziamo i pericoli delle vecchie lettiere automatiche e come il design a corpo fisso protegge il tuo gatto.',
        subtitle: 'Team Kleeo',
        slug: 'sicurezza-lettiera-automatica-confronto',
        screens: blogImg2,
        link: 'LEGGI TUTTO',
        description: 'Analizziamo i pericoli delle vecchie lettiere automatiche e come il design a corpo fisso protegge il tuo gatto.',
        author: 'Team Kleeo',
        create_at: 'Feb 15, 2026',
        blogSingleImg: blogSingleImg2,
        comment: '35',
        day: '15',
        month: 'FEB',
        blClass: 'format-standard-image',
        animation: '1200',
        tags: ['Sicurezza Gatti', 'Tecnologia Safe-Dome', 'Confronto Lettiere', 'Design Innovativo', 'Protezione Anti-Pinch'],
        content: [
            'Nel mercato delle lettiere autopulenti, la sicurezza è il tema più dibattuto. Molti modelli economici utilizzano un cilindro che ruota interamente, creando potenziali "punti di schiacciamento" dove le zampe o la coda del gatto potrebbero rimanere incastrate.',
            'Kleeo nasce con una filosofia diversa: il design Safe-Dome. A differenza della concorrenza, il guscio esterno di Kleeo rimane fisso e immobile. Il meccanismo di setacciatura avviene all\'interno di una camera protetta. Questo significa che non ci sono fessure esterne in movimento.',
            'In aggiunta, Kleeo è dotata di un triplo sistema di protezione:',
            'Celle di carico: Sensori di peso ultra-precisi che bloccano ogni movimento se rilevano una pressione superiore a 150g.',
            'Sensori a infrarossi: Una barriera invisibile all\'ingresso che arresta la macchina non appena il gatto si avvicina.',
            'Design Anti-Pinch: Struttura meccanica pensata per non avere mai due parti metalliche o plastiche che si chiudono "a forbice".',
            'Scegliere Kleeo significa scegliere la tranquillità totale per te e per il tuo amico a quattro zampe.',
        ],
    },
    {
        id: '3',
        title: 'Monitorare il peso del gatto: un indicatore vitale per la sua salute.',
        title2: 'Monitorare il peso del gatto: un indicatore vitale per la sua salute.',
        subtitle: 'Team Kleeo',
        slug: 'monitoraggio-peso-salute-gatto',
        screens: blogImg3,
        link: 'LEGGI TUTTO',
        description: 'Come i sensori di precisione di Kleeo e l\'App dedicata ti aiutano a prevenire problemi urinari e obesità.',
        author: 'Team Kleeo',
        create_at: 'Feb 20, 2026',
        blogSingleImg: blogSingleImg3,
        comment: '35',
        day: '20',
        month: 'FEB',
        blClass: 'format-standard-image',
        animation: '1200',
        tags: ['Salute Gatto', 'App Tuya Smart', 'Monitoraggio Peso', 'Prevenzione Veterinaria', 'IoT Pet Care'],
        content: [
            'I gatti sono maestri nel nascondere i sintomi di malessere. Spesso, quando ci accorgiamo che qualcosa non va, il problema è già in fase avanzata. Uno dei primi segnali di allarme è quasi sempre la variazione di peso o la frequenza delle visite alla lettiera.',
            'Kleeo non è solo una lettiera che ti fa risparmiare tempo, è un vero dispositivo di monitoraggio sanitario. Grazie all\'integrazione con l\'App Tuya Smart, Kleeo registra ogni sessione:',
            'Variazioni di Peso: Un calo improvviso o un aumento eccessivo vengono segnalati immediatamente sul tuo smartphone.',
            'Frequenza d\'Uso: Troppe visite in un giorno possono indicare cistiti o problemi urinari comuni nei gatti maschi.',
            'Durata della Sessione: Monitorare quanto tempo il gatto trascorre all\'interno aiuta a identificare precocemente problemi di costipazione.',
            'Avere questi dati storici a portata di mano durante una visita veterinaria può fare la differenza per una diagnosi accurata. Con Kleeo, l\'igiene della tua casa e la salute del tuo gatto viaggiano finalmente sulla stessa app.',
        ],
    },
 


];
export default blogs;



